import { createFileRoute } from '@tanstack/react-router'

import CreatePenyuluhPusatPage from '@/components/pages/backoffice/_klb-penyuluh/_pusat/_create/containers/CreatePenyuluhProvinsiPage'

export const Route = createFileRoute('/_backoffice/klb-penyuluh/pusat/create/')(
  {
    component: CreatePenyuluhPusatPage
  }
)
